import { Component } from '@angular/core';
import {FormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {AuthenticationService} from "../services/authentication.service";
import {Router} from "@angular/router";

@Component({
    selector: 'app-password-forgotten',
    templateUrl: './password-forgotten.component.html',
    styleUrls: ['./password-forgotten.component.css'],
    standalone: false
})
export class PasswordForgottenComponent {
  credentialForm = new UntypedFormGroup({});
  accountErrorMessage: string | undefined;
  formSubmitted = false;

  constructor(
    private fb: FormBuilder,
    private authService: AuthenticationService,
    private router: Router
  ) {
    this.authService.redirectLoggedInUser();
  }

  ngOnInit(): void {
    this.credentialForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  /**
   * Attempts to send a password reset email to the provided email address.
   */
  async sendPasswordReset() {
    // Exits out of function if the credential form hasn't been filled in validly.
    if(!this.credentialForm.valid) {
      this.formSubmitted = true;
      return;
    }

    await this.authService.sendPasswordResetEmail(this.credentialForm.value.email).then(() => {
      this.router.navigate(['/account/inloggen']);
    });
  }

  /**
   * @return Filled in email value on login form.
   */
  get email() {
    return this.credentialForm.get('email');
  }
}
